function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H44.626V44.626H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.891,7H24.313a1.859,1.859,0,0,0,0,3.719h5.578a5.578,5.578,0,1,1,0,11.156H24.313a1.859,1.859,0,1,0,0,3.719h5.578A9.3,9.3,0,1,0,29.891,7ZM13.156,16.3a1.865,1.865,0,0,0,1.859,1.859H26.172a1.859,1.859,0,0,0,0-3.719H15.016A1.865,1.865,0,0,0,13.156,16.3Zm3.719,5.578H11.3a5.578,5.578,0,0,1,0-11.156h5.578a1.859,1.859,0,0,0,0-3.719H11.3a9.3,9.3,0,0,0,0,18.594h5.578a1.859,1.859,0,0,0,0-3.719Z",
  transform: "translate(1.719 6.016)"
});

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.626 44.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b59ac577.svg";
export { ForwardRef as ReactComponent };